export default __webpack_public_path__ + "static/media/logo.7c6e94a9.png";